/* eslint-disable angular/controller-as, angular/controller-name */
(function () {
  angular.module('7Shop.Common')
    .controller('sMultiSelectGeneralItems', multiSelectGeneralItems);

  function multiSelectGeneralItems(
    $scope,
    close
  ) {
    $scope.close = close;
  }
})();
